var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWalletChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 6.96436,
    height: 12.0009,
    viewBox: "0 0 6.96436 12.0009",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line-6 (Stroke)",
    d: "M6.96436 6.00008L1.00509 12.0009L0 11.002L4.96802 6.00008L0 0.998169L1.00509 0L6.96436 6.00008Z",
    fill: "#20242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWalletChevronIcon);
export default __webpack_public_path__ + "static/media/cash-wallet-chevron-icon.8a9c527ccb602055eaeccea3455c4f85.svg";
export { ForwardRef as ReactComponent };